import React from "react";
import "../index.css";
import "../about.css";

const experience = [
  {
    title: "Founder & Director",
    org: "She Codes Too",
    location: "Iraq & UK",
    date: "Sep 2020 – present",
    highlight: true,
    achievements: [
      "Founded and led a nonprofit providing technical training for young women in Iraq, bridging education and employment in technology.",
      "Directly impacted ~400 women, achieving a 75% employment rate for programme graduates.",
      "Recognised with the University of Bristol Alumni Award 2025 and invited to speak at Chatham House, London.",
    ],
  },
  {
    title: "Trainer and Consultant",
    org: "",
    location: "Remote, UK",
    date: "Oct 2023 – Feb 2025",
    subtitle:
      "Provided project management consultancy and software training to institutions and organisations.",
  },
  {
    title: "Software Engineer",
    org: "Swedbank AB",
    location: "Stockholm, Sweden",
    date: "Mar 2022 – Jun 2023",
    subtitle:
      "Developed and maintained Swedbank's online banking platform, focusing on lending products and migration from legacy systems.",
  },
  {
    title: "Lecturer, Computer Science",
    org: "University of Information Technology and Communications",
    location: "Baghdad, Iraq",
    date: "Oct 2016 – Mar 2022",
    subtitle:
      "Designed curriculum, taught computer science courses, and supervised undergraduate student projects.",
  },
];

const education = [
  {
    title: "MSc Advanced Computing",
    org: "University of Bristol",
    location: "UK",
    date: "Sep 2014 – Mar 2016",
    subtitle:
      "Recipient of the 2025 Alumni of the Year Award for Global Citizenship.",
  },
  {
    title: "BSc Computer Science",
    org: "University of Babylon",
    location: "Iraq",
    date: "Dec 2007 – Jul 2011",
    subtitle: "",
  },
];

const Second = () => {
  return (
    <div>
      <h2 className="section-title">Background</h2>
      <div className="about-container">
        <div className="about-section">
          <div className="about-section-title">Experience</div>
          {experience.map((item) => (
            <div
              className={`about-item${item.highlight ? " about-item--highlight" : ""}`}
              key={item.title + item.org}
            >
              <div className="about-item-content">
                <div className="about-item-header">
                  <div className="about-item-title">{item.title}</div>
                  {item.org && (
                    <span className="about-item-org">{item.org}</span>
                  )}
                  <span className="about-item-location">
                    <span role="img" aria-label="location">
                      📍
                    </span>{" "}
                    {item.location}
                  </span>
                </div>
                {item.achievements ? (
                  <ul className="about-item-achievements">
                    {item.achievements.map((a, i) => (
                      <li key={i}>{a}</li>
                    ))}
                  </ul>
                ) : (
                  <div className="about-item-subtitle">{item.subtitle}</div>
                )}
              </div>
              <div className="about-item-date">{item.date}</div>
            </div>
          ))}
        </div>

        <div className="about-section">
          <div className="about-section-title">Education</div>
          {education.map((item) => (
            <div className="about-item" key={item.title}>
              <div className="about-item-content">
                <div className="about-item-header">
                  <div className="about-item-title">{item.title}</div>
                  <span className="about-item-org">{item.org}</span>
                  <span className="about-item-location">
                    <span role="img" aria-label="location">
                      📍
                    </span>{" "}
                    {item.location}
                  </span>
                </div>
                {item.subtitle && (
                  <div className="about-item-subtitle">{item.subtitle}</div>
                )}
              </div>
              <div className="about-item-date">{item.date}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Second;
